// Generated by DesignToCode

import { Component, OnInit, computed, effect, input, signal, untracked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Checkbox } from '../checkbox/checkbox';
import { RadioButton } from '../radio-button/radio-button';

@Component({
  selector: 'app-dropdown-item',
  templateUrl: './dropdown-item.html',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, Checkbox, RadioButton],
})
export class DropdownItem implements OnInit {
  public text = input<string>('');
  public icon = input<string>('');
  public showCheckbox = input<boolean>(false);
  public showRadioButton = input<boolean>(false);
  public radioControlName = input<string>('');
  public radioValue = input<any>(null);
  public showCheckmark = input<boolean>(true);
  public selected = input<boolean>(false);

  public isSelected = signal(this.selected());

  private hovered = signal(false);

  constructor() {
    effect(() => {
      const selected = this.selected();
      untracked(() => this.isSelected.set(selected));
    });
  }

  ngOnInit(): void {
    // Initial setup
  }

  public setHovered(value: boolean): void {
    this.hovered.set(value);
  }

  public toggleSelected(): void {
    this.isSelected.update((prev) => !prev);
  }

  public containerClasses = computed(() => {
    const classes: string[] = [
      'flex',
      'items-center',
      'gap-xs',
      'p-sm',
      'rounded-xs',
      'cursor-pointer',
      'group',
    ];

    if (this.isSelected()) {
      classes.push('bg-navy-blue-30');
    } else if (this.hovered()) {
      classes.push('bg-grey-20');
    } else {
      classes.push('bg-transparent');
    }

    return classes.join(' ');
  });

  public textClasses = computed(() => {
    const classes: string[] = ['font-caption', 'font-medium', 'text-sm', 'leading-lg', 'truncate'];

    if (this.isSelected()) {
      classes.push('text-grey-120');
    } else {
      classes.push('text-grey-110');
    }

    return classes.join(' ');
  });

  public iconClasses = computed(() => {
    const classes: string[] = [];

    if (this.isSelected()) {
      classes.push('fill-grey-120');
    } else {
      classes.push('fill-grey-100');
    }

    return classes.join(' ');
  });

  public checkmarkClasses = computed(() => {
    const classes: string[] = [];

    if (this.isSelected() && this.showCheckmark()) {
      classes.push('fill-grey-120');
    } else {
      classes.push('fill-none');
    }

    return classes.join(' ');
  });
}
